import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  ImageListItem,
  Stack,
  Grid,
} from "@mui/material";
import posOne from "./assets/pos/pos_1.png";
import posTwo from "./assets/pos/pos_2.png";
import posThree from "./assets/pos/pos_3.png";
import posFour from "./assets/pos/pos_4.png";
import posFive from "./assets/pos/pos_5.png";

import bestPractise from "./assets/devops/best_practise.png";

import cardPayment from "./assets/pos/card_payment.png";
import mtip from "./assets/pos/mtip.png";
import otherCard from "./assets/pos/Other_card_certification.png";
import paymentGateway from "./assets/pos/payment_gateway.png";
import qr_payment from "./assets/pos/qr_payment.png";
import secure_payment from "./assets/pos/secure_payment.png";
import visa_advt from "./assets/pos/visa_advt.png";

import { Divider } from "@mui/material";

import {
  ChevronLeft,
  ChevronRight,
  FiberManualRecord,
} from "@mui/icons-material";
import Footer from "./footer";
import { useLocation } from "react-router-dom";

const POSDevelopment = () => {
  const scrollRef = useRef();
  const { pathname } = useLocation();

  const images = [posTwo, posThree, posFour, posFive];

  const indexRef = useRef(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const scrollToIndex = (index) => {
    const width = scrollRef.current.offsetWidth;
    scrollRef.current.scrollTo({
      left: index * width,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const handleManualScroll = (direction) => {
    const newIndex =
      (indexRef.current + direction + images.length) % images.length;
    indexRef.current = newIndex;
    scrollToIndex(newIndex);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % images.length;
      scrollToIndex(indexRef.current);
    }, 3000); // every 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <Box>
      <Box maxWidth="100%">
        <Box
          sx={{
            position: "relative",
            minHeight: { xs: "50vh", md: "50vh" },
            backgroundImage: `url(${posOne})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {/* Blurred Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(2px)",
              zIndex: 1,
            }}
          />

          {/* Text Content */}
          <Box sx={{ maxWidth: "auto", mb: 4, zIndex: 2 }}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{ color: "white", fontWeight: 700 }}
            >
              POS Development
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        spacing={4}
        alignItems="top"
        justifyContent="center"
        sx={{ flexWrap: "wrap", mt: 5 }}
      >
        {/* Left: Image */}

        <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
          <Box
            sx={{
              pl: { xs: 2, md: 0 },
              pr: { xs: 2, md: 0 },
              mb: { xs: 0, md: 2 },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "orange",
                textAlign: "left",
                pb: { xs: 2, md: 2 },
              }}
            >
              POS Development
            </Typography>
            <Typography variant="body1" paragraph>
              We specialize in custom POS (Point of Sale) development tailored
              to your business environment, whether it's retail, hospitality, or
              enterprise-level service. Our systems are designed to streamline
              every stage of the transaction—from scanning items to processing
              payments—while integrating inventory, customer management, and
              analytics all in one unified platform.
            </Typography>

            <Typography variant="body1" paragraph>
              Our POS solutions support real-time data syncing, multi-location
              operations, and omnichannel integration. Whether you operate a
              small shop or a national chain, our systems adapt to your scale.
              With responsive UIs and fast checkout flows, the focus is on user
              experience, reliability, and effortless training for your staff.
            </Typography>
          </Box>
        </Grid>

        <Grid item sx={{ width: { xs: "100%", md: "35%" } }}>
          <Box
            flex={1}
            maxHeight="800px"
            overflow="auto"
            borderLeft="1px solid #ccc"
            sx={{ pl: { xs: 0, md: 2 } }}
          >
            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  maxWidth: "100%",
                  mx: "auto",
                  overflow: "hidden",
                  mt: { xs: 0, md: 4 },
                }}
              >
                <IconButton onClick={() => handleManualScroll(-1)}>
                  <ChevronLeft />
                </IconButton>

                <Box
                  ref={scrollRef}
                  sx={{
                    width: { xs: "100%", md: 600 },
                    height: { xs: "100%", md: 500 },
                    display: "flex",
                    overflowX: "hidden",
                    scrollSnapType: "x mandatory",
                  }}
                >
                  {images.map((src, index) => (
                    <ImageListItem
                      key={index}
                      sx={{
                        flex: "0 0 100%",
                        scrollSnapAlign: "center",
                      }}
                    >
                      <img
                        src={src}
                        alt={`Slide ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "16px", // Adjust as needed (e.g., 8px, 24px)
                        }}
                        loading="lazy"
                      />
                    </ImageListItem>
                  ))}
                </Box>

                <IconButton onClick={() => handleManualScroll(1)}>
                  <ChevronRight />
                </IconButton>
              </Box>

              {/* Indicators */}
              <Stack
                direction="row"
                justifyContent="center"
                mt={2}
                sx={{ mt: 5 }}
              >
                {images.map((_, index) => (
                  <IconButton
                    key={index}
                    size="small"
                    onClick={() => scrollToIndex(index)}
                  >
                    <FiberManualRecord
                      fontSize="small"
                      color={index === activeIndex ? "primary" : "disabled"}
                    />
                  </IconButton>
                ))}
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1, borderColor: "orange", mt: 5 }} />

      <Box sx={{ width: { xs: "100%", md: "80%" }, mx: "auto", mb: 5 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // centers horizontally
            px: 2,
            mt: 5,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{ color: "orange", fontWeight: "bold", mb: 1 }}
            >
              Wallet System
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              We integrate digital wallet systems that allow customers to make
              fast and secure payments using mobile phones or smart devices.
              These wallets can store loyalty points, promotional credits, and
              gift cards, enabling personalized customer experiences and repeat
              business. With support for both cloud and device-based wallets,
              our system accommodates services like Apple Pay, Google Pay, and
              proprietary business wallets. We ensure tight encryption,
              tokenization, and real-time validation for secure and seamless
              wallet transactions. needed.
            </Typography>
          </Box>
        </Box>

        {/* Centered small orange line */}
        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        {/* Content Block: Image Left, Text Right */}
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={paymentGateway}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Payment Gateway Integration
            </Typography>
            <Typography variant="body1">
              Our POS systems integrate with top-tier payment gateways to
              process credit, debit, and digital wallet transactions
              efficiently. This allows for seamless fund transfer, reduced
              payment delays, and complete support for multiple currencies and
              global transactions. We support all major gateways including
              Stripe, PayPal, Razorpay, Authorize.Net, and custom bank APIs.
              Each integration is handled with PCI compliance in mind, ensuring
              sensitive payment data is securely processed and transmitted.
            </Typography>
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Card Payment
            </Typography>
            <Typography variant="body1">
              We enable fast and secure card payments through EMV-compliant
              terminals. Whether it's chip, magnetic stripe, or contactless
              cards, our POS system handles all major transaction types with
              precision and speed. Card encryption, tokenization, and
              transaction validation are core to our system architecture. The
              result is a seamless experience for both merchants and customers,
              with built-in fraud detection and instant transaction
              confirmation.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={cardPayment}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            pb: { xs: 2, md: 0 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "20%" } }}>
            <img
              src={qr_payment}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              QR Payment
            </Typography>
            <Typography variant="body1">
              QR code-based payment systems offer a contactless, fast, and
              intuitive way for customers to pay. We implement both static and
              dynamic QR codes, linking them to payment gateways or wallet
              systems. This feature is particularly useful in quick-service
              environments, pop-up stores, and mobile POS setups. It supports
              both customer-generated (scan-to-pay) and merchant-generated
              (display-to-pay) QR codes, fully integrated with your sales
              system.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Secure Payment
            </Typography>
            <Typography variant="body1">
              Security is a top priority in our POS development. We ensure all
              transactions—whether through cards, QR codes, or wallets—are
              encrypted end-to-end using TLS protocols and tokenization
              techniques. In addition to PCI-DSS compliance, we build role-based
              access controls, session timeouts, and secure audit logs into
              every system. These measures help protect businesses from fraud,
              chargebacks, and unauthorized access.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={secure_payment}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={visa_advt}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Visa ADVT Certification
            </Typography>
            <Typography variant="body1">
              We ensure that POS systems comply with Visa's ADVT (Acquirer
              Device Validation Toolkit) certification, which is essential for
              validating chip-based card transactions on Visa networks. By
              certifying against Visa ADVT, we help merchants reduce transaction
              errors and processing issues. This certification guarantees your
              system is tested for EMV compatibility and ready for global
              acceptance.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              MTIP Certification
            </Typography>
            <Typography variant="body1">
              Our POS systems are also designed to pass MasterCard Terminal
              Integration Process (MTIP) certifications. This ensures your
              terminal is fully validated for MasterCard's EMV transaction
              requirements. The certification process includes rigorous testing
              of contact and contactless transactions, ensuring a smooth
              experience for your customers while protecting your business from
              non-compliance penalties and transaction failures.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={mtip}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={otherCard}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Other Card Payment Certification
            </Typography>
            <Typography variant="body1">
              Beyond Visa and MasterCard, we help your system meet
              certifications for networks like Amex, Discover, RuPay, and
              UnionPay. Each certification ensures compatibility, security, and
              acceptance with a broader range of card issuers. We stay updated
              with industry mandates and evolving compliance standards, so your
              POS system is always prepared for certification audits and
              international deployments. This broad compatibility expands your
              market reach and builds trust with global customers.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Best Practices
            </Typography>
            <Typography variant="body1">
              We adhere to industry-recognized best practices in everything we
              do—from secure coding standards to infrastructure automation. Our
              workflows are built around principles of agility, reliability, and
              transparency, ensuring predictable, repeatable outcomes every
              time. Whether it’s deploying a Kubernetes cluster or automating
              backups, we apply practices like infrastructure as code, version
              control, regular testing, and proactive monitoring. This
              guarantees system stability, faster recovery times, and minimal
              service disruptions.
            </Typography>
          </Grid>
          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={bestPractise}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default POSDevelopment;
